/* globals axios */
import Vue from 'vue';
import isEmpty from 'lodash/isEmpty';
import intersection from 'lodash/intersection';

Vue.component('product-slider', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            product: null,
            products: null,
            activeSlide: null,
            filters: [],
            excludes: [],
            swiper: null,
            loading: true,
        };
    },

    computed: {
        filteredProducts() {
            // If no filter, return the whole list.
            if (isEmpty(this.filters) && isEmpty(this.excludes)) {
                return this.products;
            }

            // If the inclusives are empty, use the exclusives.
            if (isEmpty(this.filters)) {
                return this.products.filter((product) => isEmpty(intersection(product.filters, this.excludes)));
            }

            // Otherwhise, the exlcusives are not empty.
            const result = this.products.filter((product) => !isEmpty(intersection(product.filters, this.filters)));

            // Now we have the includes, we just need to check if we need to filter exludes
            if (!isEmpty(this.excludes)) {
                return result.filter((product) => isEmpty(intersection(product.filters, this.excludes)));
            }

            return result;
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        EventBus.$on('product-filter-change', (data) => {
            this.filters = data.inclusives;
            this.excludes = data.excludes;

            // Vue.nextTick(this.destroySwiper);
        });

        // Make a request for a user with a given ID
        axios.get('/products.json')
        .then((response) => {
            this.products = response.data.data;
            this.loading = false;
            // Vue.nextTick(this.loadSwiper);
        })
        .catch((error) => {
            console.log(error);
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        /* loadSwiper() {
            this.swiper = new Swiper('.swiper-container', {
                init: false,
                slidesPerView: 8,
                spaceBetween: 40,
                centeredSlides: true,
                loop: true,
                initialSlide: Math.ceil(this.products.length/2),

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                breakpoints: {
                    1600: {
                        slidesPerView: 5,
                        spaceBetween: 40,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 40,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    }
                }
            })

            this.swiper.on('init', (object) => {
                this.activeSlide = this.swiper.realIndex;
                this.product = this.filteredProducts[this.activeSlide];
                this.loadRecipes();
            });

            this.swiper.on('slideChange', (object) => {
                this.activeSlide = this.swiper.realIndex;
                this.product = this.filteredProducts[this.activeSlide];
                this.loadRecipes();
            });

            this.swiper.init();
        },

        destroySwiper() {
            this.swiper.destroy();
            this.loadSwiper();
        },

        loadRecipes() {
            EventBus.$emit('product-set', this.filteredProducts[this.activeSlide]);
        } */
    },
});
